export const isAuthorMode = (): boolean => {
  return document.body.dataset.wcmmode === "edit";
};
